import React, { FC, useEffect, useState, } from "react";
import { GetServerSideProps, GetServerSidePropsContext } from "next";
import { withRouter, useRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import Head from "next/head";

import Footer from "../../../src/components/Footer/Footer";
import { readShow } from "../../../src/services/ShowService";
import { SingleShow } from "../../../src/models/Show";
import BookingManager from "../../../src/pages/Audience/BookingManager/BookingManager";
import { useColorModeContext } from "../../../src/contexts/CustomThemeProvider";

interface ShowDetailsPageProps extends WithRouterProps {
}

const ShowDetailsPage: FC<ShowDetailsPageProps> = () => {
    const router = useRouter()
    const { showUrl } = router.query
    const [show, setShow] = useState<SingleShow>();
    const promoCode = router.query.promoCode as string;

    const priority = router.query.priority as string;

    const { setColorMode } = useColorModeContext();
    setColorMode("dark");

    useEffect(() => {
        window.localStorage.removeItem("redirectURL");

        if (showUrl) {
            readShow(showUrl.toString())
                .then(response => {
                    setShow(response.data);
                })
        }
    }, [])

    return (
        <>
            <Head>
                <title>{`${show?.name} | That's The Ticket`}</title>
                <meta key="ogTitle" property="og:title" content={show?.name!} />
                <meta key="twitterTitle" name="twitter:title" content={show?.name!} />
            </Head>
            <BookingManager show={show!} promoCode={promoCode} priority={priority} />
            <Footer />
        </>
    );
}

export default withRouter(ShowDetailsPage);

export const getServerSideProps: GetServerSideProps = async ({ params }: GetServerSidePropsContext) => {

    return {
        props: {
        }
    }
}